export default __webpack_public_path__ + "static/media/Colony.770e11ca.png";